import * as _ from "lodash";
import React, { cloneElement, FC } from "react";
import ListIcon from "@material-ui/icons/List";
import {
  CreateButton,
  ListButton,
  Button,
  sanitizeListRestProps,
  TopToolbar,
} from "react-admin";
import { useHistory, useRouteMatch } from "react-router";

const ListActions: FC<any> = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  hasShow,
  hasList,
  ...rest
}) => {
  const history = useHistory();
  const sectionId = _.get(rest, "data.sectionId", undefined);

  return (
    <TopToolbar
      className={className}
      {...sanitizeListRestProps(rest)}
      hasshow={`${hasShow}`}
      haslist={`${hasList}`}>
      {!filters && (
        <Button
          component="button"
          variant="text"
          label="pos.action.listing"
          onClick={() => {
            if (sectionId) {
              history.push(`/sections/${sectionId}`);
            } else {
              history.goBack();
            }
          }}>
          <ListIcon style={{ fontSize: "20" }} />
        </Button>
      )}
      {filters &&
        cloneElement(filters, {
          undoable: "false",
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}
      {/* <CreateButton basePath={basePath} /> */}
    </TopToolbar>
  );
};

export default ListActions;
